/* global modForm modUtils */
import { getFormDataCookie } from '../../helpers';

export function saveFormDataToCookie(data = {}) {
	const currentData = getFormDataCookie();
	if (currentData) {
		data = {...JSON.parse(currentData), ...data};
	}

	if (modForm.opts.quadLinkParams) {
		data = { ...data, ...modForm.opts.quadLinkParams };
	}

	if (Object.keys(data).length) {
		Object.entries(data).forEach(([key, value]) => {
			data[key] = encodeURIComponent(value);
		});
	}

	modUtils.setCookie('formData', JSON.stringify(data), 1440);
}
